export enum StorageKey {
    USER = 'USER',
    SITE = 'SITE',
    FORM = 'FORM',
    JOB = 'JOB',
    TOKEN = 'TOKEN',
    REFRESHTOKEN = 'REFRESHTOKEN',
    CONFIGURATION = 'CONFIGURATION',
    MODULE = 'MODULE',
    FILESETTINGS = "FILESETTINGS",
    PROCESSFLOW = "PROCESSFLOW",
    LINKTYPE = "LINKTYPE",
    QRSITE = "QRSITE",
    FIRSTREDIRECT="FIRSTREDIRECT",
    SIGNIN = "SIGNIN",
    OUTOFRANGE = "OUTOFRANGE",
    SITEVISITREASONS = "SITEVISITREASONS",
    OUTOFRANGERETRYCOUNT = "OUTOFRANGERETRYCOUNT",
    OUTOFRANGEPREVIOUSNOTIFICATIONTIME = "OUTOFRANGEPREVIOUSNOTIFICATIONTIME",
    OUTOFRANGENOTIFICATIONSUCCESSFUL = "OUTOFRANGENOTIFICATIONSUCCESSFUL",
    SIGNINMETHOD = 'SIGNINMETHOD',
    PERMITQNA = 'PERMITQNA',
    LANGUAGE = 'LANGUAGE',
    AZURELOCALE = 'AZURELOCALE',
    TDSID = 'TDSID',
    CURRENTPROFILE = 'CURRENTPROFILE'
}

export enum RegisterStatus {
    Step1 = 1,
    Step2,
    Step3
}

export enum ConfigurationKey {
    PROFILERAPIDGLOBALREQUIRED = 'Profile_RapidGlobalRequired',
    PROFILEINDUCTIONREQUIRED = 'Profile_InductionRequired',
    INDUCTIONMODULEENABLE = 'InductionModuleEnable',
    ISSITELISTJOBCOUNTENABLE = 'IsSiteListJobCountEnable',
    BLOCKSEARCHINDEXING = 'BlockSearchIndexing',
    PREVIOUSCONFIGURATIONCHECKTIME = 'PreviousConfigurationCheckTime',
    GOOGLEPLAYURL = 'GooglePlayUrl',
    APPLESTOREURL = 'AppleStoreUrl',
    PRIVACYPOLICYLINK = 'PrivacyPolicyLink',
    TERMSCONDITIONLINK = 'TermsConditionLink',
    JOBLISTBATCHSIZE = 'JobListRenderBatchSize',
    TECHNICALUSERPROFILEGUIDE = 'TechnicianUserProfileGuide',
    USERMANAGEMENTGUIDE = 'UserManagementGuide',
    SUBCONTRACTORVISITSTOCITYPARTNERSGUIDE = 'SubcontractorVisitsToCityPartnersGuide',
    OUTOFRANGENOTIFICATIONINTERVALINMINUTES = 'OutOfRangeNotificationIntervalInMinutes',
    OUTOFRANGENOTIFICATIONMAXRETRYCOUNT = 'OutOfRangeNotificationMaxRetryCount',
    NEEDHELPDOCURL = 'NeedHelpDocUrl',
    PERMITKEY = 'PermitKey',
    ISMULTILANGUAGEENABLE = 'IsMultiLanguageEnable',
    ISGOOGLESSOENABLE = 'IsGoogleSSOEnable',
    ISAPPLESSOENABLE = 'IsAppleSSOEnable',
    ISIDLECHECKINGENABLE = 'IsIdleCheckingEnable',
    IDLECHECKINGFREQUENCYSECONDS = 'IdleCheckingFrequencySeconds',
    ISSITEDISTANCEDISPLAYENABLE = 'IsSiteDistanceDisplayEnable',
    GEOLOCATIONINTERVALINSECONDS = 'GeolocationIntervalInSeconds',
    MAXSIGNINSIGNOUTPHOTOS = 'MaxSignInSignOutPhotos',

    JOB_ISUPLOADJOBPHOTOSREQUIRED = 'Job_IsUploadJobPhotosRequired',
    JOB_ENABLEREACTIVEJOBPHOTOS = 'Job_EnableReactiveJobPhotos',
    JOB_ENABLEPPMJOBPHOTOS = 'Job_EnablePPMJobPhotos',
    JOB_JOBPHOTOMAXSIZEINBYTES = 'Job_JobPhotoMaxSizeInBytes',
    JOB_JOBPHOTOMAXCOUNT = 'Job_JobPhotoMaxCount',

    JOB_ENABLEPPMJOBSUPPORTINGDOCUMENTS = 'Job_EnablePPMJobSupportingDocuments',
    JOB_NOOFENABLEPPMJOBSUPPORTINGDOCUMENTSALLOWED = 'Job_NoOfEnablePPMJobSupportingDocumentsAllowed',

    JOB_ENABLEREACTIVEJOBSUPPORTINGDOCUMENTS = 'Job_EnableReactiveJobSupportingDocuments',
    JOB_NOOFENABLEREACTIVEJOBSUPPORTINGDOCUMENTSALLOWED = 'Job_NoOfEnableReactiveJobSupportingDocumentsAllowed',

    JOB_SUPPORTINGDOCUMENTALLOWFILETYPES = 'Job_SupportingDocumentAllowFileTypes',
    JOB_SUPPORTINGDOCUMENTALLOWMAXSIZEINMBS = 'Job_SupportingDocumentAllowMaxSizeInMBs',

    JOB_NOOFENABLEREACTIVEJOBSERVICESHEETSALLOWED = 'Job_NoOfEnableReactiveJobServiceSheetsAllowed',
    JOB_NOOFENABLEPPMJOBSERVICESHEETSALLOWED = 'Job_NoOfEnablePPMJobServiceSheetsAllowed',

    JOB_SERVICESHEETALLOWFILETYPES = 'Job_ServiceSheetAllowFileTypes',
    JOB_SERVICESHEETALLOWMAXSIZEINMBS = 'Job_ServiceSheetAllowMaxSizeInMBs',

    JOB_INVOICEFILEPREFIX = 'Job_InvoiceFilePrefix',
}

export enum UserType {
    BACKEND_USER = 'Backend',
    INTERNAL_USER = 'Internal',
    EXTERNAL_USER = 'External',
    CITY_ADMIN = 'City Admin'
}

export enum CompanyType {
    SELF = 'SELF',
    PARENT = 'PARENT',
    SUBCON = 'SUBCON'
}

export enum FastLinkType {
    Closedown = 1,
    Job
}

export enum InvitationSource {
    NONE = 1,
    RESOURCEADMIN = 2,
    INTERNAL = 3,
    EXTERNAL = 4
}

export enum InvitationType
{
    ADD = 1,
    DELETE = 2
}

export enum JobType {
    REACTIVE_JOB = 'REACTIVE',
    PPM_JOB = 'PPM'
}

export enum OpenJobsListType {
    NEW = 'NEW',
    ON_SITE = 'ON-SITE',
    RETURNING = 'RETURNING',
    AWAITING_PARTS = 'AWAITING-PARTS'
}

export enum AllocationMode {
    INTERNAL = 'internal',
    EXTERNAL = 'external'
}

export enum AllocationType {
    INTERNAL = 1,
    EXTERNAL = 2
}

export enum JobStatus {
    CALLOUT = 'CALLOUT',
    ONSITE = 'ONSITE',
    RETURNING = 'RETURNING',
    AWAITING_PARTS = 'AWAITING PARTS',
    COMPLETED = 'COMPLETED',
    PENDING_ADMIN_APPROVAL = 'PENDING ADMIN APPROVAL',
    FAULT_CANCELLED = 'FAULT CANCELLED',
    MISSED = 'MISSED',
    FIXED = 'FIXED',
    CANCELLED = 'CANCELLED'
}

export enum Version {
    LATESTAPPVERSION = 'LATESTAPPVERSION',
    ISFORCE = 'ISFORCE',
    PREVIOUSVERSIONCHECKTIME = 'PREVIOUSVERSIONCHECKTIME'
}

export enum AppPlatform {
    WEB = 1,
    MOBILEAPP = 2
}

export enum CityComplianceStatus {
    COMPLIANT = 1 ,
    NOTCOMPLIANT = 2 ,
    NOTAPPLICABLE = 3 ,
}

export enum DisplayedComplianceStatus {
    statusCompliant = "site_compliance_status_compliance",
    statusNotCompliant = "site_compliance_status_non-compliance",
    statusNotApplicable = "site_compliance_status_not_applicable",
}

export enum DefaultCompanyType {
    NO_COMPANY_SPECIFIED = 'No Company Specified',
    CITYFM = 'City FM',
    CITYFMASIA = 'City FM Asia'
}

export enum SignInMethod {
    QR = 'QR',
    GPS = 'GPS',
    FASTLINK = 'FASTLINK'
}

export enum PermitStatus {
    NEW = 0,
    DRAFT = 1,
    SUMBITTED = 2,
    CLOSED = 3,
    DISABLED = 99,
    NA = 100
}

export enum CityWorkType {
    NONCITYWORK = "noncifyfmwork"
}

export enum CompanySource {
  COMSII = 'COMSII',
  COMS365 = 'COMS365'
}

export enum SiteInductionStatus {
  COMPLIANCE = 'Compliance',
  NON_COMPLIANCE = 'Non Compliance',
  EXPIRED = 'Expired'
}

export enum InductionFormGroupKeys {
  BRAND_NAME = 'brandName',
  INDUCTION_ID = 'inductionId'
}

export enum ClosedownFileTypeKey {
    PHOTO = 'photo',
    SUPPORTING_DOCUMENT = 'supporting-document',
    SERVICE_SHEET = 'service-sheet'
}

export enum FileUploadTypeCode {
    PHOTO = 'UD',
    SUPPORTING_DOCUMENT = 'SD',
    SERVICE_SHEET = 'SS'
}